import React from 'react';
import './styles/Blog.css';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'Getting Started with React',
      excerpt: 'Learn the basics of React and how to set up your first React application with create-react-app.',
      date: 'June 15, 2023',
      image: 'https://via.placeholder.com/800x400?text=React+Basics',
      link: 'https://react.dev/learn'
    },
    {
      id: 2,
      title: 'CSS Grid vs Flexbox',
      excerpt: 'A comparison between CSS Grid and Flexbox layouts and when to use each one for responsive web design.',
      date: 'July 22, 2023',
      image: 'https://via.placeholder.com/800x400?text=CSS+Grid+vs+Flexbox',
      link: '/#'
    },
    {
      id: 3,
      title: 'State Management in React',
      excerpt: 'Exploring different state management solutions in React applications from useState to Redux.',
      date: 'August 10, 2023',
      image: 'https://via.placeholder.com/800x400?text=State+Management',
      link: '/#'
    }
  ];

  return (
    <section id="blog" className="blog-section">
      <div className="container">
        <h2 className="section-title">Latest Blog Posts</h2>
        <div className="blog-grid">
          {blogPosts.map(post => (
            <div className="blog-card" key={post.id}>
              <div className="blog-img">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="blog-content">
                <span className="blog-date">{post.date}</span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <a href={post.link} className="read-more">Read More</a>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="blog-cta">
          <a href="/#" className="btn primary-btn">View All Posts</a>
        </div> */}
      </div>
    </section>
  );
};

export default Blog;
